import type { TalentPopTrigger } from "./notification-copy";

/** Where a TalentPop interaction originated, for amplitude attribution. */
type TalentPopSurface = "button" | "notification";

/**
 * Builds the amplitude attribute payload shared by the TalentPop button and
 * notification. The only thing that varies between surfaces is `surface`;
 * the trigger discriminant and per-team id are derived identically.
 */
export function talentPopAmplitudeAttributes(
  surface: TalentPopSurface,
  trigger: TalentPopTrigger,
  teamId: string | null | undefined,
) {
  const base = { surface, teamId: teamId ?? null };
  return trigger.type === "holiday"
    ? { ...base, trigger: "holiday", holidayKey: trigger.holidayKey }
    : { ...base, trigger: "volume" };
}
